import { render, staticRenderFns } from "./EditMemberParentsView.vue?vue&type=template&id=1af5066c"
import script from "./EditMemberParentsView.vue?vue&type=script&lang=ts"
export * from "./EditMemberParentsView.vue?vue&type=script&lang=ts"
import style0 from "./EditMemberParentsView.vue?vue&type=style&index=0&id=1af5066c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports